module.exports = __webpack_public_path__ + "assets/img/35_1125.b505d92a.jpg";